import AppHeader from "@/components/AppHeader";

export default {
  name: "master-holiday-edit",
  components: {
    AppHeader
  },
  created() {
    this.getCompany();
    this.getTodayDate();
    this.getHoliday();
  },
  data() {
    return {
      holiday: {
        company_id: "",
        holiday_name: "",
        holiday_date: "",
        is_holiday: 0
      },
      holidayYear: "",
      holidayMonth: "",
      holidayDay: "",
      holidayDayCount: "",
      canChoiceYears: [],
      companies: "",
      getCompaniesEnd: false,
      getHolidayEnd: false
    };
  },
  computed: {
    holidayDayFormat() {
      return this.holidayYear + "-" + this.holidayMonth + "-" + this.holidayDay;
    }
  },
  methods: {
    getTodayDate() {
      let today = new Date();
      let currentYear = today.getFullYear();
      let calcMonth = today.getMonth() + 1;
      let calcDay = today.getDate();

      for (let i = 0; i < 10; i++) {
        this.canChoiceYears.push(currentYear - i);
      }
      this.holidayDayCount = new Date(calcMonth, calcDay, 0).getDate();
    },
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompaniesEnd = true;
    },
    async getHoliday() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_HOLIDAY", {
          id: this.$route.params.holiday_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });

      this.holiday.company_id = res.holiday.company_id;
      this.holiday.holiday_date = res.holiday.holiday_date;
      this.holidayYear = parseInt(res.holiday.holiday_date.substr(0, 4));
      this.holidayMonth = parseInt(res.holiday.holiday_date.substr(5, 2));
      this.holidayDay = parseInt(res.holiday.holiday_date.substr(8, 2));
      this.holiday.holiday_name = res.holiday.holiday_name;
      this.holiday.is_holiday = res.holiday.is_holiday;
      this.getHolidayEnd = true;
    },
    async editHoliday() {
      this.holiday.holiday_date = this.holidayDayFormat;
      let data = this.holiday;
      let res = await this.$store
        .dispatch("EDIT_HOLIDAY", {
          id: this.$route.params.holiday_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.$router.push({ path: "/master_holiday" });
      }
    },
    goMasterHoliday() {
      this.$router.push({ path: "/master_holiday" });
    },
    getDayCount() {
      this.holidayDay = "";
      this.holidayDayCount = new Date(
        this.holidayYear,
        this.holidayMonth,
        0
      ).getDate();
    }
  }
};
